import React, {useRef, useState} from 'react';
import {Input as UInput} from '../../components/input';
import {Form} from '@unform/web';
import * as Yup from 'yup';
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import I18nMessage from '../../components/I18nMessage';
import ReactSelect from '../../components/react-select';
import {TextArea} from '../../components/textarea';
import ToggleButton from '../../components/toggle-button';
import useServices from '../../hooks/use-services';
import Button from '../../components/button';
import UInputMask from '../../components/react-mask';
import moment from 'moment';
import useAlerts from '../../hooks/use-alerts';
import {useIntl} from 'react-intl';

const SinisterCloseForm = (props) => {
    const {
        sinister,
        loadIncidents,
        close,
        setHideClass,
    } = props;

    const schema = Yup.object().shape({
        id: Yup.number().notRequired(),
        date: Yup.string().required(),
        time: Yup.string().required(),
        closingType: Yup.string().required(),
        vehicleDamaged: Yup.boolean().required(),
        closingAddress: Yup.string().required(),
        closingDescription: Yup.string().required(),
    });

    const intl = useIntl();
    const {toast} = useAlerts();
    const [loading, setLoading] = useState(false);
    const formRef = useRef(null);
    const {sinisterService} = useServices();


    const handleSubmit = async (payload) => {
        try {
            setLoading(true);
            await schema.validate(payload, {
                abortEarly: false,
            });
            payload = schema.cast(payload);

            const {
                id,
                closingType,
                closingAddress,
                closingDescription,
                vehicleDamaged,
            } = payload;

            await sinisterService.close({
                id,
                closingDate: moment(`${payload.date} ${payload.time}`, `${intl.formatMessage({id: 'dateFormat'})} HH:mm`).toDate().toISOString(),
                closingType,
                vehicleDamaged,
                closingAddress,
                closingDescription,
            });
            loadIncidents();
            close();
            toast.success(intl.formatMessage({id: 'sinisterClosedSuccess'}));
            setHideClass('hide-card');
        } catch (err) {
            toast.errorStatus(intl.formatMessage({id: 'sinisterCloseError'}));
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
            }
            props.dispatchAccordionResize();
        } finally {
            setLoading(false);
        }
    };

    return (<Form
            ref={formRef}
            initialData={{
                id: sinister.id,
                date: moment().format(intl.formatMessage({id: 'dateFormat'})),
                time: moment().format('HH:mm'),
                vehicleDamaged: false,
            }}
            onSubmit={handleSubmit}>

            <UInput hidden type="number" name="id"/>

            <FormGroup className="custom-formGroup">
                <Label for="name"><I18nMessage id="sinisterClosingType"/>*</Label>
                <ReactSelect
                    id={'closingType'}
                    name="closingType"
                    options={[
                        {id: 'vehicleFound', title: intl.formatMessage({id: 'sinisterTypeVehicleFound'})},
                        {id: 'vehicleNotFound', title: intl.formatMessage({id: 'sinisterTypeVehicleNotFound'})},
                        {id: 'falsePositive', title: intl.formatMessage({id: 'sinisterTypeFalsePositive'})},
                    ]}/>
            </FormGroup>

            <Row>
                <Col>
                    <FormGroup className="custom-formGroup">
                        <Label for="name">
                            {intl.formatMessage({id: 'sharedDate'})}*
                        </Label>
                        <UInputMask name={'date'} mask={'99/99/9999'}/>
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup className="custom-formGroup">
                        <Label for="name">{intl.formatMessage({id: 'sinisterTimeField'})}</Label>
                        <UInputMask name={'time'} mask={'99:99'}/>
                    </FormGroup>
                </Col>
            </Row>

            <FormGroup className="custom-formGroup">
                <Label for="name"><I18nMessage id="sinisterVehicleDamaged"/>*</Label>
                <ToggleButton name={'vehicleDamaged'} id={'vehicleDamaged'}/>
            </FormGroup>

            <FormGroup className="custom-formGroup">
                <Label for="name"><I18nMessage id="sinisterClosingAddress"/></Label>
                <Input
                    tag={UInput}
                    type="text"
                    name="closingAddress"
                    id="closingAddress"
                />
            </FormGroup>

            <FormGroup className="custom-formGroup">
                <Label for="name"><I18nMessage id="sinisterClosingDescription"/></Label>
                <TextArea
                    type="text"
                    name="closingDescription"
                    id="closingDescription"
                />
            </FormGroup>

            <Row>
                <Col> <Button
                    color={'warning'}
                    disabled={loading}
                    className={'outline'}
                    size={'sm'}
                    onClick={() => close()}>
                    {intl.formatMessage({id: 'sharedCancel'})}
                </Button></Col>
                <Col>
                    <Button
                        color={'success'}
                        disabled={loading}
                        className={'outline'}
                        size={'sm'}
                        onClick={() => formRef.current.submitForm()}>
                        {intl.formatMessage({id: 'sharedSave'})}
                    </Button>
                </Col>
            </Row>

        </Form>
    );
};

export default SinisterCloseForm;
